import keyMirror from 'keymirror';
import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export const GLOBAL_MESSAGING_ID = 'global-messaging-id';

export const NO_OP_ACTION_TYPE = 'NO_OP_ACTION_TYPE';

export const STATUS_TYPES = keyMirror({
  Success: null,
  Failure: null,
  Neutral: null
});

export default createReduxConstants('MESSAGING', {
  CLEAR_MESSAGING: null
});
